export default __webpack_public_path__ + "static/media/howWeCreate.d587ee29.svg";